import { SaveButton, differenceBetweenTwoObjects } from 'src/admin/core'
import { useFormikContext } from 'formik'
import { useUpsertProgramOwner } from '../../hooks'
import { useAppTranslation, useNotification } from 'src/admin/core/hooks'
import { ProgramOwner } from '../../models'

export const UpdateButton: React.FC<{
  owner: ProgramOwner
  afterSave?: (promise: Promise<any>, action: string) => void
}> = ({ owner, afterSave }) => {
  const { upsertProgramOwner, loading, error } = useUpsertProgramOwner()
  const form = useFormikContext()
  const { values, dirty, isValid, setSubmitting } = form
  const { label } = useAppTranslation()
  const { successNotification, errorNotification } = useNotification()

  const handleSave = () => {
    const formValues = values as ProgramOwner
    const changes = differenceBetweenTwoObjects(formValues, owner)

    const response = upsertProgramOwner({
      variables: {
        input: {
          id: formValues.id,
          ...changes,
        },
      },
    })
    response
      .then(() => {
        successNotification(label('DATO_ACTUALIZADO'))
      })
      .catch(() => {
        errorNotification(label('ERROR_REGISTRANDO_EL_DATO'))
      })
    if (afterSave) {
      afterSave(response, 'update')
    }
    setSubmitting(false)
  }

  return <SaveButton onClick={handleSave} isLoading={loading} disabled={!dirty} />
}
